<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage } from '../types';
	import SbRichtext from '../components/sbRichtext.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: ISbRichtext;
			subheadline: ISbRichtext;
			background_asset_mobile: SbImage;
			background_asset_desktop: SbImage;
			cta: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();

	let cssVars = $derived([
		`--bg-src-mobile: url(${content.background_asset_mobile.filename})`,
		`--bg-src-desktop: url(${content.background_asset_desktop.filename})`
	]);
</script>

<section
	use:editable={content}
	id="hero"
	class="relative h-[85vh] text-white lg:text-brown-1"
	style={cssVars.join(';')}
>
	<PageGrid16
		margin
		class="flex h-full flex-col justify-center max-lg:justify-end"
		gridClass="max-lg:mb-13"
	>
		<div
			class="col-span-full text-pretty text-[52px]/[108%] font-semibold tracking-[-1.04px] lg:col-start-2 lg:col-end-9 lg:text-[80px]/[100%] lg:tracking-[-1.6px]"
		>
			<SbRichtext text={content.headline} />
		</div>
		<div
			class=" col-span-full mt-3 text-pretty text-[20px]/[140%] tracking-[-.2px] lg:col-start-2 lg:col-end-8 lg:mt-5 lg:text-[24px]/[140%] lg:tracking-[-.24px]"
		>
			<SbRichtext text={content.subheadline} />
			{#each content.cta as cta}
				<div class="mt-6 flex lg:mt-8">
					<Blok content={cta} />
				</div>
			{/each}
		</div>
	</PageGrid16>
</section>

<style lang="scss">
	section {
		background-image: var(--bg-src-mobile);
		background-size: cover;
		background-position: center;

		@media (min-width: 1024px) {
			background-image: var(--bg-src-desktop);
		}
	}
</style>
